$(function () {
    $(document).on('click', '[data-copy-to-clipboard]', function () {
        navigator.clipboard.writeText($(this).data('copy-to-clipboard'));
    })
    $(document).on('click', '[data-copy-to-clipboard-without-host]', function () {
        navigator.clipboard.writeText(window.location.origin + $(this).data('copy-to-clipboard-without-host'));
    })
});
